/* Miris Blend — partnerships page.
   Two jobs: gentle scroll reveal, and lazy-loading the background videos so the
   page does not fetch every clip at once. Progressive enhancement only. */
(function () {
  if (window.__mbPartnerInit) return;
  window.__mbPartnerInit = true;

  var root = document.documentElement;

  function loadAll() {
    document.querySelectorAll('video[data-mb-src]').forEach(function (v) {
      if (!v.src) v.src = v.getAttribute('data-mb-src');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  if (!('IntersectionObserver' in window)) {
    loadAll();
    return;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) root.classList.add('mb-js');

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mb-in');
        revealObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
  );

  // Videos start with no src at all. They are attached just before they scroll
  // into view and paused again once they leave, so only what is being watched
  // is ever downloaded or decoded.
  var videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.src) v.src = v.getAttribute('data-mb-src');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    },
    { rootMargin: '300px 0px', threshold: 0.01 }
  );

  function scan() {
    if (!reduce) {
      document.querySelectorAll('.mb-reveal:not(.mb-in)').forEach(function (el) {
        revealObserver.observe(el);
      });
    }
    document.querySelectorAll('video[data-mb-src]').forEach(function (v) {
      videoObserver.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
